import {
  Integer,
  IpAddress,
  NonEmptyText,
  SessionId,
  Source,
  Url,
  UserId,
} from '@hc-frontend/core-types';
import { z } from 'zod';

export const CreateProspectRequestDto = z
  .object({
    sessionId: SessionId,
    userId: UserId,
    landingUrl: Url,
  })
  .required()
  .merge(
    z
      .object({
        landingPage: Url,
        tcpaUserAgent: NonEmptyText,
        src: Source,
        ipAddress: IpAddress,
      })
      .partial(),
  );

export type CreateProspectRequestDto = z.infer<typeof CreateProspectRequestDto>;

export const CreateProspectResponseDto = z.object({
  leadId: Integer,
  leadStatus: z.literal('PROSPECT'),
});

export type CreateProspectResponseDto = z.infer<
  typeof CreateProspectResponseDto
>;
